<div class="menus-table-row heads" *ngIf="!isMobile">
  <span *ngFor="let head of heads" [innerHTML]="head"></span>
</div>
  <ng-content></ng-content>
